module.exports = __webpack_public_path__ + "static/img/modal_share_project.4952a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/modal_share_project.png
// module id = 6vSv
// module chunks = 23